<template>
	<div class="section-swiper" :style="swiperBg(data.swiper.bg)">
		<!-- <img :src="require(`@/${imgpath}/${swiperPath}/${data.swiper.bg}`)" /> -->
		<swiper :options="swiperOption" class="swiper" ref="swiper">
			<swiper-slide class="swiper-item" v-for="item in data.swiper.item" :key="item.id">
				<img :src="require(`@/${imgpath}/${swiperPath}/${item}`)" />
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
		<div class="swiper-button-prev" slot="button-prev" :style="swiperArrow(data.swiper.arrow)"></div>
		<div class="swiper-button-next" slot="button-next" :style="swiperArrow(data.swiper.arrow)"></div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
	props: ['dataP', 'filenameP', 'imgpathP', 'swiperPathP'],
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			data: {
				swiper: {
					bg: 'swiper_bg.png',
					item: ['swiper_04.jpg', 'swiper_01.jpg', 'swiper_02.jpg', 'swiper_03.jpg'],
					arrow: 'swiper_arrow.png'
				}
			},
			filename: '',
			imgpath: '',
			swiperPath: '',
			swiperOption: {
				pagination: {
					el: '.swiper-pagination'
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				loop: true
			}
		};
	},
	created() {
		this.data.swiper = Object.assign({}, this.data.swiper, this.dataP.swiper);
		this.filename = this.filenameP;
		this.imgpath = this.imgpathP;
		this.swiperPath = this.swiperPathP;
	},
	methods: {
		swiperArrow(data) {
			return {
				backgroundImage: `url('${require(`@/${this.imgpath}/${this.swiperPath}/${data}`)}')`
			};
		},
		swiperBg(data) {
			return {
				backgroundImage: `url('${require(`@/${this.imgpath}/${this.swiperPath}/${data}`)}')`
			};
		}
	}
};
</script>

<style lang="scss" scoped>
%swiperArrow {
	display: block;
	position: absolute;
	top: 48%;
	left: 15px;
	width: 6vw;
	height: 6vw;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	cursor: pointer;
	border: none;
	outline: none;
}

.section-swiper {
	position: relative;
	background-repeat: no-repeat;
	background-position: center bottom;
	background-size: 80%;
	padding-bottom: 8px;
	margin-bottom: 8px;

	.swiper {
		//position: absolute;
		width: 60%;
		//top: 0;
		//left: 20%;
	}

	.swiper-button-prev {
		@extend %swiperArrow;
	}

	.swiper-button-next {
		@extend %swiperArrow;
		left: auto;
		right: 15px;
		transform: rotateY(180deg);
	}
}
</style>
